export default __webpack_public_path__ + "static/univers-rounded-roman-d3de7acd8267c6fda3e5981bb9659315.woff";